// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"49985997","885":"84c1dacb"}[chunkId] + ".chunk.js";
};